// Staff setting: the business's own Client Portal link, <site>/p/<link name>.
// Lowercase letters, numbers and single hyphens; unique; some words reserved.
import React, { useEffect, useState } from 'react';
import clientPortalAPI from './clientPortalApi';
import { formatApiError } from '../../utils/errorMessage';

export const SLUG_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export function slugHint(value) {
  if (value.length < 3 || value.length > 60) return 'Use 3 to 60 characters.';
  if (!SLUG_RE.test(value)) return 'Use lowercase letters, numbers and single hyphens only.';
  return '';
}

export default function PortalLinkSetting({ businessId }) {
  const [saved, setSaved] = useState(null);
  const [value, setValue] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let live = true;
    Promise.resolve().then(() => clientPortalAPI.portalSlug(businessId))
      .then((r) => { if (live && r && r.data) { setSaved(r.data); setValue(r.data.slug || ''); } })
      .catch((e) => { if (live) setError(formatApiError(e, 'Could not load the portal link')); });
    return () => { live = false; };
  }, [businessId]);
  const hint = value ? slugHint(value) : '';
  const save = async (e) => {
    e.preventDefault(); setMsg(''); setError('');
    if (hint) { setError(hint); return; }
    setBusy(true);
    try { const r = await clientPortalAPI.setPortalSlug(businessId, value); setSaved(r.data); setValue(r.data.slug); setMsg('Saved. New invites and emails use this link.'); } catch (err) { setError(formatApiError(err, 'Could not save the portal link')); }
    setBusy(false);
  };
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return (
    <form className="border rounded p-2 space-y-1" aria-label="Portal link" onSubmit={save}>
      <p className="font-medium">Your clients&apos; portal link</p>
      <div className="flex flex-wrap items-center gap-1">
        <span className="text-gray-600 break-all">{origin}/p/</span>
        <input value={value} onChange={(e) => setValue(e.target.value.toLowerCase())} aria-label="Portal link name" placeholder="your-business" maxLength={60} className="border rounded px-2 py-1" />
        <button type="submit" disabled={busy || !value || value === (saved && saved.slug)} className="border rounded px-3 py-1">Save</button>
      </div>
      <p className="text-xs text-gray-600">Lowercase letters, numbers and hyphens. Old /portal links keep working.</p>
      {hint && <p className="text-xs text-amber-700">{hint}</p>}
      {msg && <p className="text-xs text-green-700">{msg}</p>}
      {error && <p role="alert" className="text-xs text-red-600">{error}</p>}
    </form>
  );
}
